import { Client, JoinEvent } from 'irc-framework';
import { IRC_EVENT, IRCMessageType, tabType } from '#/types/types';
import ConnectionHandler from '#/connectionHandler';
import TabManager from '#/ui/tabManager';
import MessageHandler from '#/messageHandler';

export class JoinEventListener {
    private cH: ConnectionHandler;
    private client: Client;
    private tM: TabManager;
    private mH: MessageHandler;

    constructor(connectionHandler: ConnectionHandler) {
        this.cH = connectionHandler as ConnectionHandler;
        this.client = connectionHandler.client as Client;
        this.tM = connectionHandler.tabManager as TabManager;
        this.mH = connectionHandler.messageHandler as MessageHandler;
        this.setup();
    }

    private setup(): void {
        this.client.on(IRC_EVENT.JOIN, (event: JoinEvent) => {
            const { nick, ident, hostname, gecos, channel, time, account, tags, batch } = event;
            
            const ourNick = this.client?.user.nick;

            if (nick === ourNick) {
                const existingTab = this.tM.getTab(tabType.CHANNEL, channel);

                if (!existingTab) {
                    this.tM.addTab(tabType.CHANNEL, channel);
                } else {
                    if (existingTab.name !== channel) {
                        this.tM.updateTabName(existingTab.name, channel);
                    }
                }
                const channelTab = this.tM.getTab(tabType.CHANNEL, channel);
                if (channelTab) {
                    this.mH.addMessage(channelTab, `* ${nick} has joined ${channel}`, IRCMessageType.SYSTEM);
                }

                this.client.raw('NAMES', channel);
                this.client.raw('MODE', channel);
            } else {
                const channelTab = this.tM.getTab(tabType.CHANNEL, channel);
                if (channelTab) {
                    this.mH.addMessage(channelTab, `* ${nick} has joined ${channel}`, IRCMessageType.SYSTEM);
                }
                this.cH.refreshUserList(channel);
            }
        });
    }
}
